import request from "@/utils/request";

export default function agencyGetNotReadMessageNum() {
    return request({
        url: `/newsMessage/agencyGetNotReadMessageNum`,
        method: 'get',
    })
}
